import { QueryHookOptions, useQuery } from "@apollo/client";

import { GET_ALL_PETS } from "./pet-list.query";
import { IPetItemResponse } from "./pet-list.interface";
import { useEffect } from "react";
import { usePetStore } from "../../hooks/redux-hooks/pet-store/pet-store.service";

type PetListQuery = { getPets: { pets: IPetItemResponse[] } };

export const usePetList = (options: QueryHookOptions<PetListQuery> = {}) => {
  const { setPetList }=usePetStore();

  const { loading, data, refetch } = useQuery<PetListQuery>(GET_ALL_PETS, {
    fetchPolicy: "cache-and-network",
    ...options,
  });

  useEffect(()=>{
    if (data?.getPets?.pets) {
      setPetList(data.getPets.pets);
    }
  }, [data]);

  return {
    petsActive: data?.getPets?.pets,
    loading,
    refetch,
  };
};
